import { apiRequest } from '@/utils/request'

export function sendVerificationCode(phoneNumber) {
  return apiRequest({
    url: '/aliyunSms/sendVerificationCode/',
    method: 'post',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    data: phoneNumber
  })
}
